/**
 * Piezas de validación reutilizables por los demás esquemas.
 */
import { z } from 'zod';

/** Identificador numérico positivo (los ids de la base son enteros). */
export const idSchema = z.coerce.number().int().positive();

/**
 * Booleano que viene como texto en la URL (`?tocaRiego=true`).
 * `z.coerce.boolean()` no sirve aquí: trata el texto «false» como verdadero.
 */
export const booleanoDeTexto = z.enum(['true', 'false']).transform((valor) => valor === 'true');

/**
 * Enlace opcional. Acepta vacío o una URL http/https.
 * Se rechazan otros protocolos (por ejemplo `javascript:`) porque el enlace se muestra como
 * un `<a href>` en la web.
 */
export const enlaceHttpSchema = z
  .string()
  .trim()
  .max(500)
  .refine((valor) => valor === '' || esUrlHttp(valor), {
    message: 'Debe ser una dirección que empiece con http:// o https://',
  });

function esUrlHttp(valor: string): boolean {
  try {
    const url = new URL(valor);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

/** Fecha en texto ISO 8601, como la entrega la API. */
export const fechaIsoSchema = z.string();

/** Forma estándar de cualquier error de la API. */
export const errorApiSchema = z.object({
  error: z.object({
    /** Código estable para que la web decida qué mostrar (no cambia aunque cambie el texto). */
    codigo: z.string(),
    /** Mensaje en español apto para mostrar a una persona. */
    mensaje: z.string(),
    /** Detalle por campo cuando la validación falla. */
    detalles: z.array(z.object({ campo: z.string(), mensaje: z.string() })).optional(),
  }),
});
export type ErrorApi = z.infer<typeof errorApiSchema>;
